import { CheckCircleFilled } from '@ant-design/icons';
import type { BannerRule } from './welcomeRules';

/**
 * The Welcome Rules banner as the Listener app draws it (dark sheet, heading,
 * rules list, "Got it"). Mirrors `welcome_rules_banner.dart` in the mobile app.
 */
export function WelcomeRulesBannerPreview({
  rules,
  defaultIcon,
}: {
  rules: BannerRule[];
  /** Emoji for rules with no icon/image (banner settings); empty = tick. */
  defaultIcon?: string;
}) {
  return (
    <div
      data-testid="banner-preview"
      style={{
        width: 300,
        maxWidth: '100%',
        margin: '0 auto',
        background: '#1A0A10',
        border: '1px solid rgba(255,255,255,0.10)',
        borderRadius: 24,
        padding: '22px 18px 18px',
        color: '#F5E8E2',
        boxShadow: '0 12px 40px rgba(0,0,0,0.45)',
      }}
    >
      <div style={{ textAlign: 'center', fontSize: 20, fontWeight: 800 }}>Welcome! 👋</div>
      <div style={{ textAlign: 'center', fontSize: 13, opacity: 0.7, margin: '6px 0 14px' }}>
        Please follow these rules:
      </div>
      <div style={{ maxHeight: 280, overflowY: 'auto', display: 'grid', gap: 10 }}>
        {rules.length === 0 ? (
          <div style={{ textAlign: 'center', fontSize: 13, opacity: 0.6, padding: '18px 0' }}>
            No active rules — the banner will not appear.
          </div>
        ) : (
          rules.map((r) => (
            <div
              key={r.id}
              style={{
                display: 'flex',
                gap: 10,
                alignItems: 'flex-start',
                background: 'rgba(255,255,255,0.05)',
                borderRadius: 14,
                padding: '10px 12px',
              }}
            >
              <div style={{ width: 28, height: 28, flex: 'none', display: 'grid', placeItems: 'center', fontSize: 20 }}>
                {r.imageUrl ? (
                  <img src={r.imageUrl} alt="" style={{ width: 28, height: 28, borderRadius: 8, objectFit: 'cover' }} />
                ) : r.icon || defaultIcon ? (
                  <span>{r.icon || defaultIcon}</span>
                ) : (
                  <CheckCircleFilled style={{ color: '#FB3C7F', fontSize: 18 }} />
                )}
              </div>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 700, overflowWrap: 'anywhere' }}>{r.title}</div>
                {r.content && (
                  <div style={{ fontSize: 12, opacity: 0.7, marginTop: 2, overflowWrap: 'anywhere', whiteSpace: 'pre-line' }}>
                    {r.content}
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
      <div
        style={{
          marginTop: 16,
          background: '#FB3C7F',
          color: 'white',
          borderRadius: 14,
          textAlign: 'center',
          fontWeight: 700,
          padding: '11px 0',
        }}
      >
        Got it
      </div>
    </div>
  );
}
